import { useState } from 'react';

const useDropDown = ({ employees = [] }) => {
  const [search, setSearch] = useState('');
  const [terminal, setTerminal] = useState('');
  const [department, setDepartment] = useState('');
  const [jobTitle, setJobTitle] = useState('');

  const employeesFilters = employees.filter(field => {
    const isMatch = field[0]?.toLowerCase().includes(search.toLowerCase());
    const isTerminal = field[3] === terminal || terminal === '';
    const isDepartment = field[2] === department || department === '';
    const isjobTitle = field[1] === jobTitle || jobTitle === '';
    if (isMatch && isTerminal && isDepartment && isjobTitle) {
      return field;
    }
    return null;
  });

  return {
    setSearch,
    setTerminal,
    setDepartment,
    setJobTitle,
    employeesFilters,
  };
};

export default useDropDown;
